import { render } from "./2.OurPartners.vue?vue&type=template&id=d2a59a84&scoped=true"
import script from "./2.OurPartners.vue?vue&type=script&lang=js"
export * from "./2.OurPartners.vue?vue&type=script&lang=js"

import "./2.OurPartners.vue?vue&type=style&index=0&id=d2a59a84&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2a59a84"]])

export default __exports__